// extracted by mini-css-extract-plugin
export default {"background":"screenSaver_background__sEoFZ"};